module.exports = __webpack_public_path__ + "static/img/logo.a3b54484.png";